import { useState } from "react";
import { LockKey } from "@phosphor-icons/react";
import { adminApi, setToken, detail } from "@/lib/adminApi";

export const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const r = await adminApi.post("/admin/login", { username: username.trim(), password });
      setToken(r.data.access_token);
      onLogin();
    } catch (err) {
      setError(err?.response?.status === 401 ? "Pogrešno korisničko ime ili lozinka" : detail(err, "Prijava nije uspela."));
    } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-surface p-5">
      <form onSubmit={submit} className="flex w-full max-w-sm flex-col gap-4 rounded-[20px] border border-line bg-surface2 p-7" data-testid="admin-login-form">
        <img src="/assets/logo-full-sm.png" alt="BalkanHD Play" className="h-20 w-20 self-center object-contain" />
        <div className="flex items-center gap-2"><LockKey size={20} weight="fill" className="text-brand" /><h1 className="text-xl font-bold">Admin prijava</h1></div>
        <input className="input" placeholder="Korisničko ime" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" data-testid="admin-username-input" />
        <input className="input" type="password" placeholder="Lozinka" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" data-testid="admin-password-input" />
        {error && <p className="text-sm font-medium text-err" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy || !username || !password} className="btn-primary disabled:opacity-50" data-testid="admin-login-submit">{busy ? "Prijava…" : "Prijavi se"}</button>
      </form>
    </div>
  );
};
